import { atom } from "jotai";
import { atomEffect } from "jotai-effect";
import { atomWithStorage } from "jotai/utils";
import { delay, isEmpty } from "lodash";

import { nextRouterAtom } from "atoms/router";
import { stringStorage } from "atoms/utils";

import { unAuthenticatedRoutes } from "contexts/app";

import { Session } from "types";

import { getLoginPath, getOrCreateSessionId, onGetHijackedSession, onGetSession } from "utils/authentication-utils";

// Sessions atoms
const ironSessionAtom = atom<Session | undefined>(undefined);
ironSessionAtom.debugLabel = "ironSession";

const userSessionAtom = atom<Session | undefined>(undefined);
userSessionAtom.debugLabel = "userSession";

const previousAccountIdAtom = atomWithStorage<string | undefined>(
  "navirec-settings-previous-accountId",
  undefined,
  stringStorage,
  {
    getOnInit: true,
  }
);
previousAccountIdAtom.debugLabel = "previousAccountId";

const loadingSessionAtom = atom<boolean>(false);
loadingSessionAtom.debugLabel = "loadingSessionAtom";

const now = Date.now();
const initializeSessionEffectAtom = atomEffect((get, set) => {
  const router = get(nextRouterAtom);
  set(loadingSessionAtom, true);

  const ironSession = get(ironSessionAtom);
  const userSession: null | Session = onGetSession();
  const hijackedSession: null | Session = onGetHijackedSession();

  let session: null | Session = null;

  switch (true) {
    case !isEmpty(hijackedSession):
      if (hijackedSession) {
        session = hijackedSession;
      }
      break;
    case !isEmpty(ironSession):
      if (ironSession) {
        session = ironSession;
      }
      break;
    case !isEmpty(userSession):
      if (userSession) {
        session = userSession;
      }
      break;
  }

  if (unAuthenticatedRoutes.includes(window.location.pathname)) {
    set(loadingSessionAtom, false);
    return;
  }

  if (isEmpty(session)) {
    delay(() => {
      // delay routing due to this error: https://github.com/vercel/next.js/discussions/39040
      router?.push(getLoginPath()).finally(() => {
        set(loadingSessionAtom, false);
      });
    }, 500);
    return;
  }

  set(userSessionAtom, {
    ...session,
    sessionId: getOrCreateSessionId(),
    sessionTime: now,
    isHijacked: !isEmpty(hijackedSession),
  });
  set(loadingSessionAtom, false);
});
initializeSessionEffectAtom.debugLabel = "initializeSessionEffect";
initializeSessionEffectAtom.debugPrivate = true;

export { initializeSessionEffectAtom, ironSessionAtom, loadingSessionAtom, userSessionAtom, previousAccountIdAtom };
